import axios, { AxiosInstance } from 'axios';
import { toast } from 'react-toastify';

export class AppError {
  message: string;

  constructor(message: string) {
    this.message = message;
  }
}

type RegisterInterceptTokenManagerProps = {
  signOut: () => void;
  refreshTokenUpdated(params: string): void;
};

type APIInstanceProps = AxiosInstance & {
  registerInterceptTokenManager: ({}: RegisterInterceptTokenManagerProps) => () => void;
};
const token = localStorage.getItem('@voucher:token');

const httpApi = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,

  headers: {
    Authorization: `Bearer ${token}`,
  },
}) as APIInstanceProps;

httpApi.registerInterceptTokenManager = ({ signOut }) => {
  const interceptTokenManager = httpApi.interceptors.response.use(
    (response) => response,
    async (requestError) => {
      if (requestError.request.status === 401 || requestError.resquest.status === 502) {
        signOut();
        toast.success('Seu token expirou, você será desconectado.');
      }

      if (requestError.response && requestError.response.data) {
        return Promise.reject(new AppError(requestError.response.data));
      } else {
        return Promise.reject(requestError);
      }
    },
  );

  return () => {
    httpApi.interceptors.response.eject(interceptTokenManager);
  };
};

export { httpApi };
